import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-customIndigo text-white py-10">
      {/* Outer Container */}
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 text-center md:text-left">
        {/* Left Section */}
        <div className="col-span-1 md:mx-auto">
          <img src="/Logo_CPS.png" alt="PT. CPS Logo" className="h-12 w-auto mb-4 mx-auto md:mx-0 bg-white" />
          <p className="mb-4">
            <a href="mailto:info@centralprimasukses.co.id" className="hover:underline">
              info@centralprimasukses.co.id
            </a>
          </p>
          <p className="mb-4 font-bold">(0778) 4884 062</p>
          <p>Union Industrial Park A2/10, Batu Ampar, Batam - 29444</p>
        </div>

        {/* Center Section */}
        <div className="text-center md:mx-auto">
          <h4 className="text-lg font-bold mb-4">Information</h4>
          <ul>
            <li className="mb-2"><a href="/home" className="hover:underline">Home</a></li>
            <li className="mb-2"><a href="/about" className="hover:underline">About Us</a></li>
            {/* <li className="mb-2"><a href="/brands" className="hover:underline">Brands</a></li> */}
            <li className="mb-2"><a href="/products" className="hover:underline">Products</a></li>
            <li className="mb-2"><a href="/contact-us" className="hover:underline">Contact Us</a></li>
          </ul>
        </div>

        {/* Right Section (Optional for Future Use) */}
        {/* Uncomment if needed */}
        {/* <div className="text-center md:mx-auto">
          <h4 className="text-lg font-bold mb-4">Follow Us</h4>
          <ul className="flex justify-center space-x-4">
            <li>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                <img src="/facebook-icon.png" alt="Facebook" className="h-8 w-8" />
              </a>
            </li>
            <li>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                <img src="/instagram-icon.png" alt="Instagram" className="h-8 w-8" />
              </a>
            </li>
            <li>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                <img src="/linkedin-icon.png" alt="LinkedIn" className="h-8 w-8" />
              </a>
            </li>
          </ul>
        </div> */}
      </div>

      {/* Footer Bottom */}
      <div className="container mx-auto text-center mt-8 border-t border-customIndigo pt-4">
        <p>Copyright © 2024 - PT. CENTRAL PRIMA SUKSES</p>
      </div>
    </footer>
  );
};

export default Footer;
